export const comments_5588480 = {"data":{"data":[],"links":{}}}